// extracted by mini-css-extract-plugin
export default {"paper":"MenuControls_paper__oaR-q","divider":"MenuControls_divider__f5-nl","buttonWrapper":"MenuControls_buttonWrapper__EVCew","buttonIcon":"MenuControls_buttonIcon__Hq76d"};